import {
  GET_OFFERS_LIST_REQUEST,
  GET_OFFERS_LIST_SUCCESS,
  GET_OFFERS_LIST_FAILURE,
} from "../../../Utils/Constant";

export const offerListRequest = (payload) => {
  return {
    type: GET_OFFERS_LIST_REQUEST,
    payload: payload,
  };
};

export const offerListSuccess = (data) => {
  return {
    type: GET_OFFERS_LIST_SUCCESS,
    payload: data,
  };
};

export const offerListFailure = (error) => {
  return {
    type: GET_OFFERS_LIST_FAILURE,
    payload: error,
  };
};
